import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, TimeScale, BarElement, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels"

import './i18n';
import FallbackUILoader from './components/loader/FallbackUILoader';
import { isProductionMode } from './constant/ApplicationVariables';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, TimeScale, ChartDataLabels);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  isProductionMode ? (
    <App />
  ) : (
    <React.StrictMode>
      {/* <Suspense fallback={<FallbackUILoader />}> */}
      <App />
      {/* </Suspense> */}
    </React.StrictMode>
  ));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
